import type { ErrorFlow } from '@mathflat/shared/@modules/errorReporting'
import type { AxiosRequestConfig } from 'axios'
import type { ResErr } from 'src/types/common/api'

type CommonErrorParams = {
  // 'network' = 응답이 없는 실패. 타임아웃·네트워크 단절·CORS 가 모두 여기로 오는데
  // 브라우저가 이 셋을 구분해주지 않으므로 한 값으로 둔다.
  type?: 'API' | 'client' | 'network'
  disableToast?: boolean
  config?: AxiosRequestConfig
  // 결제처럼 "상태와 무관하게 항상 보고" 하는 흐름 표시. 파이프라인이 toAppError 로 읽는다.
  flow?: ErrorFlow
} & Partial<Pick<Response, 'status' | 'url'> & ResErr>

export class CommonError<DataT = null> extends Error {
  override name = 'CommonError'
  status?: CommonErrorParams['status']
  type?: CommonErrorParams['type']
  code?: ResErr['code']
  data?: ResErr<DataT>['data']
  disableToast: CommonErrorParams['disableToast']
  config?: CommonErrorParams['config']
  flow?: ErrorFlow

  constructor(message: string, options?: CommonErrorParams) {
    super(message)
    Object.assign(this, options)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CommonError)
    }
  }
}
